var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{attrs:{"width":"lg"}},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"white section--header loading"},[_vm._v(_vm._s(_vm.$store.state.settings.redirect_page_string))])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('PrismicImage',{attrs:{"img":_vm.$store.state.settings.redirect_page_image}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }